module.exports = __webpack_public_path__ + "static/SLCS-logo-b367b057c3efe44fc7640c9c5b22166e.png";